import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import IconButton from '@material-ui/core/IconButton';

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton
} from 'react-share';

import FacebookIcon from 'mdi-material-ui/Facebook';
import LinkedinIcon from 'mdi-material-ui/Linkedin';
import TwitterIcon from 'mdi-material-ui/Twitter';
import EmailIcon from 'mdi-material-ui/Email';

const ShareWidget = styled.div`
  display: flex;
  margin-bottom: ${props => (props.direction === 'horizontal' ? 0 : '40px')};
  position: sticky;
  top: ${props => props.top || '20px'};
  justify-content: ${props => props.justify || 'space-between'};

  div[role='button'] {
    outline: none;
    width: 48px;
  }

  @media (min-width: 960px) {
    flex-direction: ${props =>
      props.direction === 'horizontal' ? 'row' : 'column'};
  }
`;

class SocialShare extends React.PureComponent {
  render() {
    const { url, color } = this.props;

    return (
      <ShareWidget {...this.props}>
        <TwitterShareButton url={url}>
          <IconButton color={color}>
            <TwitterIcon />
          </IconButton>
        </TwitterShareButton>
        <LinkedinShareButton url={url}>
          <IconButton color={color}>
            <LinkedinIcon />
          </IconButton>
        </LinkedinShareButton>
        <FacebookShareButton url={url}>
          <IconButton color={color}>
            <FacebookIcon />
          </IconButton>
        </FacebookShareButton>
        <EmailShareButton url={url}>
          <IconButton color={color}>
            <EmailIcon />
          </IconButton>
        </EmailShareButton>
      </ShareWidget>
    );
  }
}

SocialShare.defaultProps = {
  color: 'primary'
};

SocialShare.propTypes = {
  url: PropTypes.string.isRequired
};

export default SocialShare;
